import { Selector } from '@ngxs/store';
import { ToetsenStateModel } from '@store/models/toetsen.model';
import { ToetsenState } from '@store/states/toetsen.state';

export class ToetsenSelectors {
  @Selector([ToetsenState])
  static toetsen(state: ToetsenStateModel) {
    return state.toetsen || [];
  }

  @Selector([ToetsenState])
  static toetsenLoading(state: ToetsenStateModel) {
    return state.isLoading;
  }

  @Selector([ToetsenState])
  static toetsenError(state: ToetsenStateModel) {
    return state.error;
  }

  @Selector([ToetsenState])
  static toetsenLoaded(state: ToetsenStateModel) {
    return state.isLoaded;
  }

  @Selector([ToetsenState])
  static toetsenPeriods(state: ToetsenStateModel) {
    return state?.periods;
  }
}
